import request from '@/request/loginRequest'

// 登录接口
export function login(query) {
  return request({
    url: '/localSso/login',
    method: 'post',
    params: query,
    headers: {
      isToken: false
    }
  })
}

//本地单点登录：使用accessToken
export function ssoLogin(data) {
  return request({
    url: '/localSso/ssoLogin',
    method: 'post',
    data,
    headers: {
      isToken: false,
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}

//本地单点登录：使用accessToken
export function refreshToken(query) {
  return request({
    url: '/permissionInfo/refreshToken',
    method: 'post',
    params: query,
    headers: {
      isToken: false
    }
  })
}

// 获取用户信息
export function getUserInfo(username) {
  return request({
    url: '/user/info/' + username,
    method: 'get',
    headers: {
      "Content-Type": 'application/json,text/plain,*/*'
    }
  })
}

// 获取路由信息
export function getRouters() {
  let systemId = global.$config.app.systemId || 1
  return request({
    url: '/menu/getRouters',
    method: 'get',
    params: {systemId}
  })
}

// 登出-操作日志
export function getLogOut() {
  return request({
    url: '/localSso/logout',
    method: 'post'
  })
}
export function validateAccessToken(accessToken) {
  return request({
    url: '/permissionInfo/validateAccessToken',
    method: 'post',
    params: {accessToken}
  })
}


